import {
	Coded, 
	CustomerTransactionDto, 
	Id
} from "../../../models/businesses";

const key = "fake-customer-transactions";

const applicable = (resp) => {
	// api/businesses/${businessId}/customers/${customerId}/transactions
	const matches = (resp.config.method === "GET") && resp.config.url.match(/api\/businesses\/[0-9]*\/customers\/[0-9]*\/transactions/);
	
	return matches;
};

const modify = (resp) => {
	if(resp.status !== 404 && resp.status !== 403 && resp.status !== 405) {
		throw resp;
	}

	resp.status = 200;
	resp.data.Success = true;
	delete resp.data.Errors;
	delete resp.data.Informations;

	const data: CustomerTransactionDto[] = [
		{
			Id: 123 as Id<"CustomerTransaction">,
			Code: "47d56ab5-fb71-43ff-a5cc-e6aca17bb58d" as Coded<"CustomerTransaction">,
			ReferenceNumber: 123,
			Note: "Note 1",
			IsActive: true,
			Transaction: {
				Item: "Item 1",
				Price: 1,
				Fees: [
					{ Fee: { Code: "0193e641-fd4b-7096-9a9b-100e88c83470" as Coded<"FeeDto"> }, Amount: 10 },
					{ Fee: { Code: "0193e643-4fb6-75e1-b5d4-ea286fff9a9a" as Coded<"FeeDto"> }, Amount: 4 }
				],
				Fee: 14,
				Subtotal: 2,
				Total: 3
			},
			Created: "01/02/2021",
			Invoices: [
				{
					Id: "2",
					State: {
						Code: "755ae2f0-d398-4c93-b035-3b5f6ca28783",
						IsVoid: false,
						IsPaid: false
					}
				}
			]
		},
		{
			Id: 45 as Id<"CustomerTransaction">,
			Code: "3bbad9eb-6b99-4a8d-ab3e-4beac2eeb700" as Coded<"CustomerTransaction">,
			ReferenceNumber: 456,
			Note: "Note 2",
			IsActive: true,
			Transaction: {
				Product: { Code: "0193e648-540f-7513-9959-1523d4254b28" as Coded<"ProductDto"> },
				Quantity: 4,
				Price: 5,
				Fees: [
					{ Fee: { Code: "0193e641-fd4b-7096-9a9b-100e88c83470" as Coded<"FeeDto"> }, Amount: 3 },
					{ Fee: { Code: "0193e643-4fb6-75e1-b5d4-ea286fff9a9a" as Coded<"FeeDto"> }, Amount: 3 }
				],
				Fee: 6,
				Subtotal: 6,
				Total: 7
			},
			Created: "01/03/2021",
			Invoices: []
		}
	];

	resp.data.Data = data;

	return resp;
};

export const fakeCustomerTransactions = [key, applicable, modify];